import logo from "../assets/recall-rush-logo.png";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full px-4">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={logo} alt="image" className="w-16 h-16 rounded-lg" />
        <h1 className="mt-4 text-[#af61dd] text-4xl font-bold">
          Privacy Policy: How Recall Rush Protects Your Information
        </h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2025-01-23
        </p>
        <div className="details mt-4">
          <p>
            This Privacy Policy ("Policy") explains how Recall Rush ("we," "us,"
            or "our") collects, uses, and protects your personal information
            when you use our mobile application ("App"). We are committed to
            protecting the privacy of children and comply with applicable laws,
            such as COPPA, to ensure a safe and secure experience for young
            users.
          </p>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Information We Collect</h1>
            <div className="subsec ml-5 mt-2">
              <h3 className="text-xl font-bold">
                Information You Provide Directly:
              </h3>
              <ul className="list-disc list-outside mt-1">
                <li>
                  <strong>Account Information:</strong> When children create an
                  account or interact with the App, they may provide certain
                  personal information like name, username, and
                  parent/guardian’s email (if required).
                </li>
                <li className="mt-1">
                  <strong>In-App Activities:</strong> Information related to
                  game progress such as completed levels, achievements, and
                  preferences within the App.
                </li>
              </ul>
            </div>
            <div className="subsec ml-5 mt-4">
              <h3 className="text-xl font-bold">
                Information Collected Automatically:
              </h3>
              <ul className="list-disc list-outside mt-1">
                <li>
                  <strong>Device Information:</strong> Basic information about
                  the device used to access the App such as device type,
                  operating system, and IP address.
                </li>
                <li className="mt-1">
                  <strong>Usage Data:</strong> Non-personal data such as modes
                  of play, achievements, and interactions with the App, which
                  helps improve user experience.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Use of Your Information</h1>
            <ul className="list-disc list-outside ml-5 mt-2">
              <li>
                To operate and provide the App for children to enjoy, track
                progress, and access age-appropriate content.
              </li>
              <li>
                To improve the App, fix bugs, personalize the experience, and
                develop new features.
              </li>
              <li>
                To provide customer support and respond to inquiries or issues.
              </li>
              <li>
                To process in-app purchases, with parental consent where
                applicable.
              </li>
              <li>
                To send age-appropriate communications to parents/guardians
                about updates, features, or promotions with consent.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Sharing of Your Information</h1>
            <p className="mt-1">
              We do not share personally identifiable information (PII) with
              third parties for marketing purposes. We may share certain
              non-personally identifiable data with trusted third-party service
              providers to help operate and improve the App. These third parties
              are bound by confidentiality agreements and prohibited from using
              the information for any other purposes.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Data Retention</h1>
            <p className="mt-1">
              We will retain children's information only for as long as
              necessary to fulfill the purposes outlined in this Policy or as
              required by law. If an account is closed, we may retain certain
              data for legal compliance or operational purposes.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Security</h1>
            <p className="mt-1">
              We take reasonable steps to protect children’s personal
              information from unauthorized access or disclosure. However, no
              method of electronic storage or transmission is 100% secure, and
              we cannot guarantee complete security.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Parental Consent</h1>
            <p className="mt-1">
              We require parental consent for the collection and use of personal
              information from children under the age of 13. Parents can review,
              correct, or delete any personal information provided by their
              child.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Your Choices</h1>
            <ul className="list-disc list-outside ml-5 mt-2">
              <li>
                Parents or guardians can access, modify, or delete their child's
                account information by contacting support or managing the
                child's profile in the App.
              </li>
              <li>
                Parents may unsubscribe from promotional emails or notifications
                by following the unsubscribe instructions or adjusting
                preferences in the App.
              </li>
              <li>
                Parents can delete their child’s account by contacting support
                or using the account settings in the App. Upon deletion, we will
                remove personal information unless retention is necessary for
                legal purposes.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Security</h1>
            <p className="mt-1">
              We take reasonable measures to protect your information from
              unauthorized access, disclosure, alteration, or destruction.
              However, no Internet transmission or electronic storage method is
              100% secure.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Your Choices </h1>
            <p className="mt-1">
              You can access and update your account information at any time.
              You can also unsubscribe from marketing communications by
              following the instructions in those communications.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Children's Privacy</h1>
            <p className="mt-1">
              Recall Rush is designed specifically for children. We do not
              knowingly collect personal information from children under the age
              of 13 without verified parental consent. If you are a parent or
              guardian and believe your child has provided us with personal
              information, please contact us immediately, and we will remove it.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Changes to This Policy</h1>
            <p className="mt-1">
              We may update this Privacy Policy occasionally to reflect changes
              in practices, technology, or legal requirements. Any changes will
              be posted on this page with an updated "Last Updated" date.
              Parents are encouraged to review the policy periodically.
            </p>
          </div>
        </div>
      </div>

      <footer className="w-full mt-10 py-4 bg-neutral-100 text-[#af61dd] text-center">
        <h1>
          All Rights Reserved{" "}
          <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
        </h1>
      </footer>
    </div>
  );
}
